(function ($) {
    if($('.promo-block').length>0) {
        $('.promo-block').each(function () {
            if($(this).find('.img-wrapper').length==0) {
                $(this).addClass('no-img');
            }
        });

    }
})(jQuery);